import React, { useEffect, useRef } from 'react';

const SmoothGallerySlider = () => {
  const galleryImages = [
    "/gallery/gallery1.jpg",
    "/gallery/gallery2.jpg",
    "/gallery/gallery3.jpg",
    "/gallery/gallery4.jpg",
    "/gallery/gallery5.jpg",
    "/gallery/gallery6.jpg",
    "/gallery/gallery7.jpg",
    "/gallery/gallery8.jpg"
  ];

  const sliderRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      if (sliderRef.current) {
        const scrollAmount = sliderRef.current.offsetWidth / 4; // Slide by one image width
        sliderRef.current.scrollBy({
          left: scrollAmount,
          behavior: 'smooth',
        });

        // Reset to start when reaching end
        if (
          sliderRef.current.scrollLeft + sliderRef.current.clientWidth >=
          sliderRef.current.scrollWidth - 1
        ) {
          setTimeout(() => {
            sliderRef.current.scrollTo({ left: 0, behavior: 'smooth' });
          }, 1000);
        }
      }
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="gallery-slider-section" style={{ padding: '60px 20px', backgroundColor: '#f9f9f9' }}>
      <div style={{ maxWidth: '1100px', margin: '0 auto', textAlign: 'center' }}>
        <h2 style={{ fontSize: '1.75rem', marginBottom: '30px', color: '#125303' }}>Gallery</h2>

        <div
          ref={sliderRef}
          style={{
            display: 'flex',
            overflowX: 'hidden',
            gap: '20px',
            scrollBehavior: 'smooth',
          }}
        >
          {galleryImages.map((img, idx) => (
            <img
              key={idx}
              src={img}
              alt={`Gallery ${idx + 1}`}
              style={{
                width: '25%',
                height: '180px',
                flexShrink: 0,
                objectFit: 'cover',
                borderRadius: '10px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                transition: 'transform 0.3s ease',
              }}
            />
          ))}
        </div>

        <div style={{ marginTop: '30px' }}>
          <a
            href="/gallery"
            style={{
              backgroundColor: '#125303',
              color: '#fff',
              padding: '12px 30px',
              borderRadius: '6px',
              textDecoration: 'none',
              fontWeight: 'bold',
            }}
          >
            View Full Gallery
          </a>
        </div>
      </div>
    </section>
  );
};

export default SmoothGallerySlider;
